module.exports = __webpack_public_path__ + "static/img/h5-01.3990228.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/h5-01.jpeg
// module id = DrK3
// module chunks = 2